import Page from 'components/Page';
import React, {Component} from 'react';
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  CardFooter,
  Col,
  Form,
  FormGroup,
  Label,
  Row,
} from 'reactstrap';


import Cargando from './../components/Cargando';
import TablaCalificaciones from './../components/TablaCalificaciones';
import Confirmar from '../components/ModalConfirmar'; 
import ModalGestorActividad from '../components/ModalGestorActividad';

import SelectCiclos from './../components/SelectCiclos'
import SelectActividades from './../components/SelectActividades';


import Actividad from './../api/Actividad'; 
import Estudiante from './../api/Estudiante'; 
import Calificacion from './../api/Calificacion';

const estudiante = new Estudiante();
const actividad = new Actividad(); 
const calificacion = new Calificacion();

class GestorCalificaciones extends Component {

    constructor(props) {
      super(props);
      this.state = {
        modal: false,
        ciclo:'',
        actividad:'',
        listadoActividades :[],
        listadoEstudiantes:[],
        usuario:'',
        nada:'',
        confirmarGuardar:false,
        cargando:false,
        actividadDis:true
      }
    }
  

    listadoActividades = async () => {
        let listado = await actividad.mostrar(); 
        this.setState({listadoActividades: listado}); 
    }


    listadoEstudiantes = async (ciclo) => {
        this.setState({cargando:true})
        let listado = [];
        //llamada de estudiantes inscritos en el ciclo especifico
        let estudiantes = await estudiante.porCiclo(ciclo);

        // se llena arreglo con objeto con datos para la calificacion
        for (const i in estudiantes) {
            let itemEstudiante = { 
                idNota:'',
                nombreEstudiante: estudiantes[i].estudiante_nombre,
                idEstudiante: estudiantes[i].estudiante_id,
                ciclo : ciclo, 
                actividad:'',
                profesor:this.state.usuario,
                nota:''
            }
            listado.push(itemEstudiante)
        }


        this.setState({listadoEstudiantes: listado, cargando:false}); 
         
    }

    visualizacionNotas = async(actividad) => {
        this.setState({cargando:true})

        let actividad_id = actividad!=="Seleccione"  ? JSON.parse(actividad).id : null;  
        let alumnos = this.state.listadoEstudiantes;  
        let ciclo_id =  alumnos.length>0 ?alumnos[0].ciclo:null; 
          
        let notas = await calificacion.notaCicloAactividad(ciclo_id, actividad_id);

        
        for (let i in alumnos) {
            alumnos[i].actividad = actividad_id;
            alumnos[i].idNota =  '';
            alumnos[i].nota = '';
            if(notas.length>0){
                for (let e in notas) {
                    if(notas[e].estudiante_id===alumnos[i].idEstudiante){
                        alumnos[i].idNota = notas[e].id ? notas[e].id : '';
                        alumnos[i].nota = notas[e].nota ? notas[e].nota: '';
                    } 
                }
            } 
        }
 
        this.setState({ listadoEstudiantes: alumnos, cargando:false }) 

    }

    cambiarNota = (e, index) =>{
        const alumnos = this.state.listadoEstudiantes;  
        alumnos[index].nota = e.target.value
        this.setState({ listadoEstudiantes: alumnos })     
    }
  
    toggleModal = () => {
      this.setState(prevState => ({
        modal: !prevState.modal
      }));
    }
    

    manejaCiclo = (evento) => {
        this.setState({ciclo: evento.target.value})

        this.listadoEstudiantes(evento.target.value);

        if (evento.target.value!=='Seleccione' && evento.target.value!=='') {
            this.setState({actividadDis:false}) 
        }else {
            this.setState({actividadDis:true, actividad:''})   
        }
    }


    manejaActividad = async (evento) => {
        this.setState({actividad: evento.target.value})
       
        this.visualizacionNotas(evento.target.value)
          
    }

    mostrarDatos = async () => {
        const {ciclo, actividad} = this.state;
        let lc = await this.listadoEstudiantes(ciclo);
        let la = await this.visualizacionNotas(actividad);

        this.setState({nada:lc})
        this.setState({nada:la})
        
    }


    guardarNotaIndividual = async (e) => {
        let resultado = await calificacion.ingresar(e.nota, e.ciclo, e.actividad, e.profesor, e.idEstudiante)
        if(resultado!=="ok"){
            console.log(resultado)
        }

        this.mostrarDatos();
    }

    editarNotaIndividual = async (e) => {
        let resultado = await calificacion.editar(e.idNota, e.nota, e.ciclo, e.actividad, e.profesor, e.idEstudiante)
        if(resultado!=="ok"){
            console.log(resultado)
        }
        this.mostrarDatos();
    }

    guardarTodo = (estudiantes) =>{
        for (const i in estudiantes) {
            if(estudiantes[i].idNota===''){
                this.guardarNotaIndividual(estudiantes[i])
            }else {
                this.editarNotaIndividual(estudiantes[i])
            }
        }
    }

    componentDidMount(){
        this.setState({usuario:this.props.user.rut})
        this.listadoActividades();

    }

    muestraConfirmarGuardar = () => {
        this.setState(prevState => ({
            confirmarGuardar: !prevState.confirmarGuardar
        }));    
    }

    render(){

        const {ciclo, actividad, listadoActividades, listadoEstudiantes, confirmarGuardar, cargando, actividadDis} = this.state;

   
        return (
            <Page title="Administrador de calificaciones" breadcrumbs={[ { name: 'Calificaciones', active: true } ]}>
                <Cargando valor={cargando}/>
                <Card>
                    <CardHeader>Detalle de la calificación</CardHeader>
                    <CardBody>
                    <Form>
        
                        <Row className="no-margin-bottom">
                            <Col  lg={2} md={4} sm={12}>
                                <FormGroup>
                                    <Label >Ciclo</Label>
                                    <SelectCiclos  maneja={this.manejaCiclo} ciclo={ciclo} />
                                </FormGroup>
                            </Col>
                            <Col  lg={2} md={4} sm={12}>
                                <FormGroup>
                                    <Label >Actividad   <Button color="info" size="sm" onClick={this.toggleModal} className="btn-label">
                                    Administrar
                                </Button></Label>
                                    <SelectActividades  maneja={this.manejaActividad} actividad={actividad} listado={listadoActividades} disabled={actividadDis}/>
                                </FormGroup>
                            </Col>


                        </Row>

                        <Row>
                            <Col >
                                <TablaCalificaciones 
                                    estudiantes={listadoEstudiantes}
                                    actividad={actividad}
                                    cambiarNota={this.cambiarNota}
                                    guardarNotaIndividual={this.guardarNotaIndividual}
                                    editarNotaIndividual={this.editarNotaIndividual}
                                />                  
                            
                            </Col>
                            
                        </Row>
            
                    </Form>
                    </CardBody>
                    {actividad!=='' && actividad!=='Seleccione' && 
                        <CardFooter> 
                            <div className="div-nota">Se guardaran todas las calificaciones de la actividad seleccionada</div>
                            <Button color="success" size="sm" onClick={this.muestraConfirmarGuardar}>
                            Guardar 
                            </Button>

                        </CardFooter>
                    }

                </Card> 

                <ModalGestorActividad 
                    isOpen={this.state.modal}
                    toggle={this.toggleModal}
                    actualiza={this.listadoActividades}
                />

                <Confirmar 
                    isOpen={confirmarGuardar} 
                    toggle={this.muestraConfirmarGuardar} 
                    texto={"¿Esta seguro de guardar todas las calificaciones de la actividad?"} 
                    funcion={()=>this.guardarTodo(listadoEstudiantes)} 
                />

            </Page>
        );
    };
}
export default GestorCalificaciones;
